export default {
  title: {
    jobList: '职位列表',
    jobDetail: '职位详情'
  },
  menu: {
    jobList: '职位列表'
  },
  label: {
    title: '公司主页',
    jobAlert: '职位提醒',
    followUs: '关注我们',
    availableJobs: '全部职位',
    totalJobCount: '共有 {count} 个职位',
    jobLocationCount: '共有 {count} 个地址招聘',
    remoteWork: '远程办公',
    outsideWork: '海外',
    keyword: '关键字',
    shareButton: '推荐 / 分享 '
  },
  placeholder: {
    searchJobs: '搜索职位',
    searchPlaceholder: '请输入{keyName}',
    filter: '关键字搜索'
  },
  btn: {
    createJobAlert: '创建职位提醒',
    EditJobAlert: '编辑职位提醒'
  },
  message: {
    noJob: '抱歉！暂无此类工作',
    tryOtherKeyword: '请尝试搜索其他关键词 :)'
  }
}
